import React from "react";
import { Link } from "react-router-dom";

function Card({ item, index }) {

  const categoryAccents = [
    "#ff1674",
    "#2878ff",
    "#8b3dff",
    "#ff8a00",
    "#00b894",
    "#00a8ff",
  ];

  const accent =
    categoryAccents[index % categoryAccents.length];

  return (
    <Link
      to={`/categories/${item?.slugPath || item?.slug}`}
      className="custom-category-card"
      style={{
        "--category-accent": accent,
      }}
    >

      {/* Number */}
      <span className="custom-category-number">
        {String(index + 1).padStart(2, "0")}
      </span>

      {/* Image */}
      <div className="custom-category-image">
        <img
          src={item?.image}
          alt={item?.name || "Category"}
        />
      </div>

      {/* Content */}
      <div className="custom-category-content">


        <h3>{item?.name}</h3>
        

        {item?.shortDescription && (
          <p>{item.shortDescription}</p>
        )}

        <span className="custom-category-explore">
          Explore Now

          <span className="custom-category-arrow">
            →
          </span>
        </span>

      </div>

    </Link>
  );
}

export default Card;